/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Status_OfflineInputs */

const bn_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্র্যাফিক অফলাইন`)
};

const de_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkehr offline`)
};

const el_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κυκλοφορία εκτός σύνδεσης`)
};

const en_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic Offline`)
};

const es_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tráfico sin conexión`)
};

const fr_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafic hors ligne`)
};

const hi_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यातायात ऑफ़लाइन`)
};

const hu_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgalom Offline`)
};

const id_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lalu Lintas Offline`)
};

const it_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffico offline`)
};

const ja_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインのトラフィック`)
};

const ko_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오프라인 트래픽`)
};

const nl_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkeer offline`)
};

const pl_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruch offline`)
};

const pt_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tráfego off-line`)
};

const ru_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трафик офлайн`)
};

const sv_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trafik offline`)
};

const tr_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çevrimdışı Trafik`)
};

const uk_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трафік офлайн`)
};

const vi_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao thông ngoại tuyến`)
};

const zh_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线流量`)
};

const zh_hant_cipher_status_offline = /** @type {(inputs: Cipher_Status_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`離線流量`)
};

/**
* | output |
* | --- |
* | "Traffic Offline" |
*
* @param {Cipher_Status_OfflineInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_status_offline = /** @type {((inputs?: Cipher_Status_OfflineInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Status_OfflineInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_status_offline(inputs)
	if (locale === "de") return de_cipher_status_offline(inputs)
	if (locale === "el") return el_cipher_status_offline(inputs)
	if (locale === "en") return en_cipher_status_offline(inputs)
	if (locale === "es") return es_cipher_status_offline(inputs)
	if (locale === "fr") return fr_cipher_status_offline(inputs)
	if (locale === "hi") return hi_cipher_status_offline(inputs)
	if (locale === "hu") return hu_cipher_status_offline(inputs)
	if (locale === "id") return id_cipher_status_offline(inputs)
	if (locale === "it") return it_cipher_status_offline(inputs)
	if (locale === "ja") return ja_cipher_status_offline(inputs)
	if (locale === "ko") return ko_cipher_status_offline(inputs)
	if (locale === "nl") return nl_cipher_status_offline(inputs)
	if (locale === "pl") return pl_cipher_status_offline(inputs)
	if (locale === "pt") return pt_cipher_status_offline(inputs)
	if (locale === "ru") return ru_cipher_status_offline(inputs)
	if (locale === "sv") return sv_cipher_status_offline(inputs)
	if (locale === "tr") return tr_cipher_status_offline(inputs)
	if (locale === "uk") return uk_cipher_status_offline(inputs)
	if (locale === "vi") return vi_cipher_status_offline(inputs)
	if (locale === "zh") return zh_cipher_status_offline(inputs)
	return zh_hant_cipher_status_offline(inputs)
});